import { useRouter } from 'next/router';

import { useQuery } from 'react-query';
import { ExploreData } from 'services/explore';

import useExplore from 'components/pages/explore/explorewrapper/useExplore';

import FeaturedContent from 'components/pages/explore/featurecontent/FeaturedContent';
import ExploreSearchWrapper from 'components/pages/explore/exploresearchwrapper/ExploreSearchWrapper';
import FeaturedCareerPath from 'components/pages/explore/explorewrappernew/featuredcareerpath/FeaturedCareerPath';
import ExploreSearchWrapperNew from 'components/pages/explore/explorewrappernew/exploresearchwrappernew/ExploreSearchWrapperNew';
import Spinner from '@core/components/spinner/Spinner';
import IsoCertificate from 'components/pages/explore/explorewrappernew/isocertificate/IsoCertificate';
import PopularSearch from 'components/pages/explore/explorewrappernew/popularsearch/PopularSearch';
import VideoTestimonials from '@core/components/videotestimonials/VideoTestimonials';
import CourseSuggestion from '@core/components/coursesuggestion/CourseSuggestion';
import TopCareerPath from 'components/pages/explore/explorewrappernew/topcareerpath/TopCareerPath';
import ExploreCareerPaths from 'components/pages/explore/explorewrappernew/explorecareerpaths/ExploreCareerPaths';
import ExploreFaq from 'components/pages/explore/explorewrappernew/explorefaq/ExploreFaq';

import classes from './ExploreWrapperNew.module.scss';



const ExploreWrapperNew = () => {
    const router = useRouter();

    const {
        searchKeyword,
        selectedCategories,
        selectedContent,
        selectedOrdering,
        selectedCareerPath,
        selectedPrice,
        selectedStatus,
        selectedProficiency,
        selectedPage,
        selectedHighlighted,
        handleCategoryClick,
        handlePriceClick,
        handlePriceSelect,
        handleProficiencyClick,
        handleProficiencySelect,
        handleStatusSelect,
        handleQueryKeywordChange,
        handleContentTypeSelect,
        handleOrderingChange,
        handleCareerPathChange,
        handlePageChange,
        handleHighlighted,
    } = useExplore();

    const { data, isLoading } = useQuery(
        ['explore-data', router.query.featured_contents],
        () => ExploreData.GET(router.query.featured_contents),
        { enabled: !!router.isReady }
    );

    return (
        <div>
            {data && router.isReady && !isLoading ? (
                <>
                    <div className="container ">
                        <div className='row justify-content-center'>
                            <div className="col-xxl-10 col-12">
                                {data?.data?.featured_career_paths && data?.data?.featured_career_paths?.length > 0 && !searchKeyword && (
                                    <FeaturedCareerPath content={data?.data?.featured_career_paths} />
                                )}
                                <ExploreSearchWrapperNew
                                    filters={data?.data?.filters}
                                    searchData={{
                                        searchKeyword,
                                        selectedCategories,
                                        selectedContent,
                                        selectedOrdering,
                                        selectedCareerPath,
                                        selectedPrice,
                                        selectedStatus,
                                        selectedProficiency,
                                        selectedPage,
                                        selectedHighlighted
                                    }}
                                    handleCategoryClick={handleCategoryClick}
                                    handlePriceClick={handlePriceClick}
                                    handlePriceSelect={handlePriceSelect}
                                    handleProficiencyClick={handleProficiencyClick}
                                    handleProficiencySelect={handleProficiencySelect}
                                    handleStatusSelect={handleStatusSelect}
                                    handleQueryKeywordChange={handleQueryKeywordChange}
                                    handleContentTypeSelect={handleContentTypeSelect}
                                    handleOrderingChange={handleOrderingChange}
                                    handleCareerPathChange={handleCareerPathChange}
                                    handlePageChange={handlePageChange}
                                    handleHighlightedChange={handleHighlighted}
                                />
                            </div>
                        </div>
                    </div>
                    <IsoCertificate />
                    <PopularSearch />
                    {data && router.isReady && data?.data?.featured_career_paths && data?.data?.featured_career_paths?.length > 0 && !searchKeyword && (
                        <TopCareerPath career_paths={data?.data?.featured_career_paths} />
                    )}
                    <CourseSuggestion type='long' />
                    <VideoTestimonials />
                    <ExploreCareerPaths />
                    <ExploreFaq />
                </>
            ) : (
                <div className="d-flex align-items-center justify-content-center h-100 w-100 py-5">
                    <Spinner />
                </div>
            )}
        </div>
    );
};

export default ExploreWrapperNew;
